import parsley from 'parsleyjs'

const $form = $('.informational-packet-form')

export default {
  can: () => $form.length,
  run: () => {
    $form.on('submit', e => {
      e.preventDefault()

      $.ajax({
        url: $form.prop('action'),
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: resp => {
          if (resp.success) {
            $form.addClass('form--success')

            if (resp.file) {
              const download = document.createElement('form')
              download.action = resp.file
              $(document.body).append(download)
              download.submit()
            }
          }
          else {
            $form.addClass('form--error')
          }
        }
      })
    })
  }
}
